import { render, staticRenderFns } from "./Volumes.vue?vue&type=template&id=35692d9f&scoped=true"
import script from "./Volumes.vue?vue&type=script&lang=js"
export * from "./Volumes.vue?vue&type=script&lang=js"
import style0 from "./Volumes.vue?vue&type=style&index=0&id=35692d9f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35692d9f",
  null
  
)

export default component.exports